import { Injectable } from '@angular/core';
import { sessoesAtivas } from 'src/app/shared/models/sessoes-ativas.models';

@Injectable({
  providedIn: 'root',
})
export class LocalStorageService {
  private itemStorageSessaoAtendimento: string = 'sessoesAtivas';

  constructor() {}

  addSessaoAtendimento(session: sessoesAtivas): void {
    const sessoes = this.getAllSessaoAtendimento();
    sessoes[session.contactId] = session.sessionId;
    this.saveAllSessaoAtendimento(sessoes);
  }

  getSessaoAtendimento(session: sessoesAtivas): sessoesAtivas {
    const sessoes = this.getAllSessaoAtendimento();
    return { contactId: session.contactId, sessionId: sessoes[session.contactId] };
  }

  getContactIdBySessionId(sessionId: string): string | null {
    const sessoes = this.getAllSessaoAtendimento();
    for (const contactId in sessoes) {
      if (sessoes[contactId] === sessionId) {
        return contactId;
      }
    }
    return null;
  }

  deleteSessaoAtendimento(session: sessoesAtivas): void {
    const sessoes = this.getAllSessaoAtendimento();
    delete sessoes[session.contactId];
    this.saveAllSessaoAtendimento(sessoes);
  }

  private clearSessaoAtendimento(): void {
    localStorage.removeItem(this.itemStorageSessaoAtendimento);
  }

  private getAllSessaoAtendimento(): Record<string, string> {
    return JSON.parse(localStorage.getItem(this.itemStorageSessaoAtendimento) || '{}');
  }

  private saveAllSessaoAtendimento(sessoes: Record<string, string>): void {
    localStorage.setItem(this.itemStorageSessaoAtendimento, JSON.stringify(sessoes));
  }

  clearAllLocalStorage(): void {
    this.clearSessaoAtendimento();
  }
}
